import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { CreateEditFlag } from "./components/create-edit/CreateEdit";
import { FlagList } from "./components/list/FlagList";
import { useTranslation } from "../../hooks/useTranslation";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const FlagDialog: React.FC<Props> = ({ open, onClose }) => {
  const [createDialog, setCreateDialog] = useState<boolean>(false);

  const { translate, translateWithoutPrefix } =
    useTranslation("pages.orders.flag");

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>{translate("title")}</DialogTitle>
        <DialogContent>
          <Button variant="contained" onClick={() => setCreateDialog(true)}>
            {translate("createFlag")}
          </Button>
          <Box mt={2}>
            <FlagList />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {translateWithoutPrefix("buttons.close")}
          </Button>
        </DialogActions>
      </Dialog>
      <CreateEditFlag
        open={createDialog}
        onClose={() => setCreateDialog(false)}
      />
    </>
  );
};
